import React, { Component } from "react";
import "./Login.css";
import { translations } from "../containers/assets/translations";
import { B2B_PROXY } from "../containers/assets/config";
import { Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import axios from "axios";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import { ToastContainer, ToastStore } from "react-toasts";

export default class Login extends Component {
  // This component contains the user login procedure.
  constructor(state) {
    super(state);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      loadingSpinner: false,
      isButtonDisabled: true,

      form: {
        userGroupCode: "",
        password: "",
        code: "",
      },
    };
  }

  componentDidMount() {
    if (
      localStorage.getItem("Authenticated") === "false" ||
      localStorage.getItem("Authenticated") === null
    ) {
      this.props.history.push("/");
    } else {
      this.props.history.push("/home");
    }
  }

  handleChange = (event) => {
    // Enable the button when the user has inserted data.
    let fieldName = event.target.name;
    let fieldVal = event.target.value;
    this.setState(
      { form: { ...this.state.form, [fieldName]: fieldVal } },
      () => {
        if (
          this.state.form.userGroupCode === "" ||
          this.state.form.password === "" ||
          this.state.form.code === ""
        ) {
          this.setState({ isButtonDisabled: true });
        } else {
          this.setState({ isButtonDisabled: false });
        }
      }
    );
  };

  handleSubmit = () => {
    // Actions to be taken when the user presses the login button.
    this.setState({ loadingSpinner: true });
    const userLoginAttempt = {
      userGroupCode: this.state.form.userGroupCode,
      password: this.state.form.password,
      code: this.state.form.code,
      lang: this.props.lang,
    };

    axios
      .post(B2B_PROXY + "/Login", {
        userLoginAttempt,
      })
      .then((res) => {
        this.setState({ loadingSpinner: true });
        if (res.data.StatusCode === "000") {
          localStorage.setItem("userid", this.state.form.userGroupCode);
          localStorage.setItem("Password", this.state.form.password);
          localStorage.setItem("UserName", this.state.form.code);
          localStorage.setItem("Authenticated", "true");

          // Array of all rights flags to be extracted from response
          const rightsKeys = [
            "CanIssueBP",
            "CanCloseTripForBP",
            "CanCancelBP",
            "CanDeleteReservation",
            "CanEditBoardingPass",
            "CanManuallyInsert",
            "CanTestPrintForIssueBc",
            "CanDoCheckin",
            "CanDoCheckout",
            "CanCheckBP",
            "CanSendOffLineData",
            "CanCloseTripForPDA",
            "CanIssueAMPDoc",
            "CanTestPrint",
            "CanUseMRZ",
            "CanReprintBoardingPass",
            "CanCreateBGR",
            "CanListViewBGR",
            "CanEditBGR",
            "CanEditOneMoreTime",
            "CanAddBGRWithMRZ",
            "CanSubmitBGR",
            "CanUnSubmitBGR",
            "CanCloseBGR",
            "CanRejectBGR",
          ];

          rightsKeys.forEach((key) => {
            // Convert "1" string to boolean true, everything else to false
            const value = res.data[key] === "1";
            localStorage.setItem(key, value);
          });

          this.props.userHasAuthenticated();
          this.props.history.push("/home");
        } else {
          ToastStore.error(res.data.StatusMessage);
          this.setState({ loadingSpinner: false });
        }
      })
      .catch((err) => {
        console.error("Login error:", err);
        ToastStore.error("Connection Error");
        this.setState({ loadingSpinner: false });
      });
  };

  render() {
    return (
      <div className="Login main">
        <Loader fullPage loading={this.state.loadingSpinner} />
        <form>
          <FormGroup bsSize="large">
            <ControlLabel>
              {translations[this.props.lang]["User Id"]}
            </ControlLabel>
            <FormControl
              className="well"
              value={this.state.form.userGroupCode}
              autoFocus
              autoComplete="new-password"
              type="text"
              name="userGroupCode"
              onChange={(event) => {
                this.handleChange(event);
              }}
            />
          </FormGroup>
          <FormGroup bsSize="large">
            <ControlLabel>
              {translations[this.props.lang]["User Name"]}
            </ControlLabel>
            <FormControl
              className="well"
              value={this.state.form.code}
              autoComplete="new-password"
              type="text"
              name="code"
              onChange={(event) => {
                this.handleChange(event);
              }}
            />
          </FormGroup>
          <FormGroup bsSize="large">
            <ControlLabel>
              {translations[this.props.lang]["Password"]}
            </ControlLabel>
            <FormControl
              className="well"
              value={this.state.form.password}
              autoComplete="new-password"
              type="password"
              name="password"
              onChange={(event) => {
                this.handleChange(event);
              }}
            />
          </FormGroup>

          <FormGroup bsSize="large">
            <ControlLabel>{translations[this.props.lang]["lang"]}</ControlLabel>
            <FormControl
              componentClass="select"
              name="lang"
              onChange={() => {
                this.props.userLanguage();
              }}
            >
              <option value="EN">
                {translations[this.props.lang]["English"]}
              </option>
              <option value="ES">
                {translations[this.props.lang]["Spanish"]}
              </option>
              <option value="FR">
                {translations[this.props.lang]["French"]}
              </option>
            </FormControl>
          </FormGroup>
          <div className="normalize" />
          <Button
            block
            className="btn btn-primary"
            bsSize="large"
            disabled={this.state.isButtonDisabled}
            onClick={() => {
              this.handleSubmit();
            }}
            type="button"
          >
            {translations[this.props.lang]["Login"]}
          </Button>
        </form>
        <ToastContainer
          store={ToastStore}
          className="toaster"
          lightBackground
          position={
            // @ts-ignore
            ToastContainer.POSITION.TOP_CENTER
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login.js